import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// import { User } from "../../types";
// import api from "../../API"

interface Code {
  auth: [] | null;
}

const initialState: Code = {
  auth: [],
};

export const codeSlice = createSlice({
  name: "code",
  initialState,
  reducers: {
    setCodeInfo: (state, action: PayloadAction<any>) => {
      // console.log('코드 ? action ??? ' , action)
      // console.log('코드 ? action.payload ??? ' , action.payload)
      state.auth = action.payload;

      // state.auth.login = true;
      // state.auth.auth = true;
    }
  },
});

export const { setCodeInfo } = codeSlice.actions;

export default codeSlice.reducer;
